module.exports = __webpack_public_path__ + "a351e42353650416bc41a406680bc5e4.png";